export const apiURL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_LOCAL_URL || 'http://localhost:8000'
    : process.env.REACT_APP_API_URL || 'https://engagement.galadrim.fr';